<template>
  <el-select v-model="jg" clearable placeholder="请选择结论">
    <el-option label="符合要求" value="符合要求"></el-option>
    <el-option label="不符合要求" value="不符合要求"></el-option>
    <el-option label="无此项" value="无此项"></el-option>
  </el-seLect>
</template>
<script>
export default {
  name: 'ZgSelectJg',
  props: {
    value: [String],
  },
  computed: {
    jg: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    }
  }
}
</script>
